module.exports = ".l_p_img a, a.add_cart_btn {\n  cursor: pointer;\n  color: #fff; }\n"